import request from "@/utils/request";
import {apiConfig} from "@/config/api";

export function pager(data) {
    return request({
        url: apiConfig.subjectList.api.pager.url,
        method: "post",
        data
    });
}

export function create(req) {
    return request({
        url: apiConfig.subjectList.api.create.url,
        method: "post",
        data: req
    });
}

export function update(req) {
    return request({
        url: apiConfig.subjectList.api.update.url,
        method: "post",
        data: req
    });
}

export function getSubject(parma) {
    return request({
        url: apiConfig.subjectList.api.getSubject.url + parma,
        method: "get",
    });
}

export function batchDelete(req) {
    return request({
        url: apiConfig.subjectList.api.batchDelete.url,
        method: "post",
        data: req
    });
}

export function exportSubjectsError() {
    return request({
        url: apiConfig.subjectList.api.exportSubjectsError.url,
        method: "get",
        responseType: "blob"
    });
}

export function getWdList() {
    return request({
        url: apiConfig.subjectList.api.getWdList.url,
        method: "get"
    });
}
